import React, { useState, useMemo } from 'react';
import MainLayout from '../../../shared/layouts/MainLayout';
import { Card, Alert, Loading, Spinner } from '../../../shared/components';
import { useReports } from '../hooks/useReports';
import { useExport } from '../hooks/useExport';
import ReportFilters from '../components/ReportFilters';
import ReportTable from '../components/ReportTable';
import ReportCharts from '../components/ReportCharts';
import ExportButtons from '../components/ExportButtons';

const getToday = () => new Date().toISOString().split('T')[0];

const IssueReportPage = () => {
  const [filters, setFilters] = useState({
    period: 'daily',
    startDate: getToday(),
    endDate: getToday(),
    medicine: '',
    patient: ''
  });

  const { data, loading, error, refetch } = useReports('issue', filters);

  const handleApplyFilters = (newFilters) => {
  setFilters(newFilters); // ✅ this alone triggers API
};
  const exportUtils = useExport();

  // Extract the actual data array from the nested structure
  const getRawDataArray = () => {
    if (!data) return [];
    
    // Based on your API response structure: { success: true, data: { type, filters, data: [...] } }
    if (data.data && data.data.data && Array.isArray(data.data.data)) {
      return data.data.data;
    }
    
    // Fallback: try data.data if it's an array
    if (data.data && Array.isArray(data.data)) {
      return data.data;
    }
    
    return [];
  };

  const rawData = getRawDataArray();

  const columns = [
    { header: 'Period', accessor: 'period' },
    { header: 'Medicine', accessor: 'medicine_name' },
    { header: 'Patient', accessor: 'patient_name', render: (value) => value || 'General' },
    { header: 'Quantity Issued', accessor: 'total_issued' },
    // { 
    //   header: 'Total Cost', 
    //   accessor: 'total_cost',
    //   render: (value) => `$${parseFloat(value).toFixed(2)}`
    // }
  ];

  // const handleApplyFilters = (newFilters) => {
  //   setFilters(newFilters);
  //   refetch();
  // };

  const handleReset = () => {
    setFilters({
      period: 'daily',
      startDate: '',
      endDate: '',
      medicine: '',
      patient: ''
    });
  };

  // Handler functions for exports
  const handleCSVExport = () => {
    exportUtils.exportToCSV(rawData, 'issue_report');
  };

  const handleExcelExport = () => {
    exportUtils.exportToExcel(rawData, 'issue_report');
  };

  const handlePDFExport = () => {
    exportUtils.exportToPDF(
      rawData, 
      columns, 
      'Medicine Issue Report', 
      'issue_report'
    );
  };

  const handlePrint = () => {
    exportUtils.print();
  };

  if (loading) return <Spinner />;
  if (error) return <Alert type="error" message={error} />;

  return (
    // <MainLayout>
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-2xl font-bold mb-6">Medicine Issue Report</h1>
        
        <ReportFilters
          filters={filters}
          onApply={handleApplyFilters}
          onReset={handleReset}
        />
        
        <ExportButtons
          data={{ data: rawData }}
          columns={columns}
          filename="issue_report"
          title="Medicine Issue Report"
          onExportCSV={handleCSVExport}
          onExportExcel={handleExcelExport}
          onExportPDF={handlePDFExport}
          onPrint={handlePrint}
        />
        
        <Card>
          <div className="p-6">
            <h2 className="text-lg font-semibold mb-4">Issue Details</h2>
            <ReportTable
              data={{ data: rawData }}
              columns={columns}
            />
          </div>
        </Card>
        
        {rawData.length > 0 && (
          <ReportCharts
            data={rawData}
            type="issue"
            title="Issue Trends"
          />
        )}
      </div>
    // </MainLayout>
  );
};

export default IssueReportPage;